var exports = {
  "zr": "x804f0401--5ec7af--root",
  "Qs": "x804f0401--5ec7af--content",
};

module.exports = exports;
